import { render, staticRenderFns } from "./_cragSectorName.vue?vue&type=template&id=1720b007"
import script from "./_cragSectorName.vue?vue&type=script&lang=js"
export * from "./_cragSectorName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports